import { normalizeSjaHazards, nextSjaStepNumber } from "./sjaHazards";
function firstPresent(record, keys, fallback = "") {
  if (!record) return fallback;
  for (const key of keys) {
    const value = record[key];
    if (value !== undefined && value !== null && value !== "") return value;
  }
  return fallback;
}

function normalizeTemplateSteps(raw) {
  const steps = Array.isArray(raw?.steps)
    ? raw.steps
    : Array.isArray(raw?.sja_steps)
      ? raw.sja_steps
      : null;
  if (steps?.length) {
    return steps.map((step, index) => ({
      step_number: step.step_number || index + 1,
      description: firstPresent(step, ["description", "title"], ""),
      hazards: normalizeSjaHazards(step),
    }));
  }
  const description = firstPresent(raw, ["description", "step_description"], "");
  const hazards = normalizeSjaHazards(raw);
  if (description || hazards.length) {
    return [{ step_number: 1, description, hazards }];
  }
  return [];
}

export function normalizeSjaStepTemplate(raw = {}, source = "api") {
  const steps = normalizeTemplateSteps(raw);
  return {
    id: raw.id,
    title: firstPresent(raw, ["title", "name"], ""),
    source: raw.source || source,
    sjaId: raw.sja_id || (source === "sja" ? raw.id : null),
    steps,
  };
}

export function normalizeSjaStepTemplates(payload, source = "api") {
  const items = Array.isArray(payload)
    ? payload
    : payload?.data || payload?.templates || payload?.step_templates || [];
  return (Array.isArray(items) ? items : [])
    .map((item) => normalizeSjaStepTemplate(item, source))
    .filter((item) => item.id || item.title);
}

export function applySjaStepTemplate(form = {}, template = {}) {
  const existing = (form.steps || []).filter(
    (step) => step.id || step._destroy || String(step.description || "").trim() ||
      normalizeSjaHazards(step).some((hazard) => hazard.description.trim() || hazard.likelihood !== "" || hazard.consequence !== "" || hazard.existing_measures || hazard.additional_measures)
  );
  const nextNumber = nextSjaStepNumber(existing);
  const added = (template.steps || []).map((step, index) => ({
    step_number: nextNumber + index,
    description: step.description || "",
    hazards: normalizeSjaHazards(step).filter((hazard) => !hazard._destroy).map(({ id, ...hazard }) => hazard),
  }));
  return added.length ? { ...form, steps: [...existing, ...added] } : form;
}
